import { render, staticRenderFns } from "./ClientBankAccountForm.vue?vue&type=template&id=1355aafe&"
import script from "./ClientBankAccountForm.vue?vue&type=script&lang=js&"
export * from "./ClientBankAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports